import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Constants } from "src/app/_consts/constants";
import { SharedService } from "src/app/_shared/shared.service";
import { Fce } from "src/app/SayTS/fce";
import { HttpPlus } from "src/app/SayTS/http-plus";
import { UiSwitchComponent } from "src/app/_compatibility/us-switch/ui-switch.component";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { NgSelectModule } from "@ng-select/ng-select";

@Component({
  selector: "app-group",
  templateUrl: "./template.component.html",
  imports: [FormsModule, TranslateModule, NgSelectModule, UiSwitchComponent],
})
export class UserTemplateComponent implements OnInit {
  template;
  newTemplate: boolean = false;
  isBrowser: boolean = false;
  modules = Constants.MODULES;
  groups;
  idObj;

  constructor(
    private activatedRoute: ActivatedRoute,
    private http: HttpPlus,
    protected shared: SharedService,
    private location: Location,
  ) {
    this.isBrowser = activatedRoute.snapshot.data.isBrowser;
    this.idObj =
      activatedRoute.snapshot.params.id_template ||
      activatedRoute.snapshot.params.id_browser;
  }

  ngOnInit(): void {
    if (this.idObj == "new") {
      this.newTemplate = true;
      this.template = {};
    }
    this.refresh();
  }

  async refresh() {
    const response: any = await this.http.get(
      this.isBrowser
        ? `userBrowser/${this.activatedRoute.snapshot.params.id_browser}`
        : `userTemplate/${this.idObj}`,
    );
    console.log(response);
    if (!response) return;
    if (response.template)
      this.template = Fce.convertForClient(response.template);
    if (response.browser)
      this.template = Fce.convertForClient(response.browser);
    const groups = {};
    if (response.groups)
      this.modules.forEach((m) => {
        groups[m] = response.groups.filter((g) => g.module == m);
      });
    this.groups = groups;
  }

  saveTemplate() {
    if (this.newTemplate || this.isBrowser) this.saveTemplate2(false);
    else
      this.shared.modalYesNo(
        "templates.change_template_head",
        "templates.change_template_text",
        () => {
          this.saveTemplate2(true);
        },
        () => {
          this.saveTemplate2(false);
        },
      );
  }

  async saveTemplate2(changeUsers) {
    const params = Fce.convertForServer({ ...this.template });
    params.change_users = changeUsers;
    console.log(params);
    const response = await this.http.put(
      this.isBrowser ? `userBrowser` : `userTemplate`,
      params,
    );
    if (response) {
      this.shared.success();
      this.location.back();
    }
  }
}
